import styled from 'styled-components';

// Overlay Dialog Component is the most visible component in coplanner-forms (z-index)
const OverlayComponent = styled.div`
	top: 0;
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: 1111113;
	background-color: rgba(154,154,154,0.6);
`;

interface IOverlayProps {
  children: React.ReactNode; // children can be any valid React node (string, JSX, other components, etc.)
}
export default function Overlay({ children }: IOverlayProps) {
	return (
		<OverlayComponent>
			{children}
		</OverlayComponent>
	);
}
